import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminBoundariesEndpoints } from '@ooh/contracts';
import type { AdminBoundaryImportTriggerResponse } from '@ooh/contracts';
import { adminBoundaryQueries } from './queries';
import type { WithCallWithAuth } from './queries';

// ─── Trigger admin boundary import ────────────────────────────────────────────

export function useTriggerAdminBoundaryImport(auth?: WithCallWithAuth) {
  const queryClient = useQueryClient();

  return useMutation<AdminBoundaryImportTriggerResponse, Error, void>({
    mutationFn: () => {
      if (!auth) {
        return Promise.reject(new Error('No auth provided'));
      }
      return auth.callWithAuth(adminBoundariesEndpoints.triggerImport, {});
    },
    onSuccess: () => {
      if (!auth) return;
      void queryClient.invalidateQueries({
        queryKey: adminBoundaryQueries.importStatus(auth).queryKey,
      });
    },
  });
}
